import ApiService from "@/api.service";
import API from "@/API";

//rule
export const GET_LIST_RULES = "listRules";
export const SET_LIST_RULES = "setListRules";
export const DELETE_RULES = "deleteRules";
export const SAVE_RULES = "saveRules";
export const GET_DETAIL_RULES = "getDetailRules";
export const SET_DETAIL_RULES = "setDetailRules";
export const UPDATE_RULES = "updateRules";
// list gift
export const GET_LIST_PROMOTIONS = "listPromotions";
export const SET_LIST_PROMOTIONS = "setListPromotions";
export const DELETE_PROMOTIONS = "deletePromotions";
export const SAVE_PROMOTIONS = "savePromotions";
export const GET_DETAIL_PROMOTIONS = "getDetailPromotions";
export const SET_DETAIL_PROMOTIONS = "setDetailPromotions";
export const UPDATE_PROMOTIONS = "updatePromotions";
// list gift packages
export const GET_LIST_PACKAGES = "listPackages";
export const SET_LIST_PACKAGES = "setListPackages";
export const DELETE_PACKAGES = "deletePackages";
export const SAVE_PACKAGES = "savePackages";
export const GET_DETAIL_PACKAGES = "getDetailPackages";
export const SET_DETAIL_PACKAGES = "setDetailPackages";
export const UPDATE_PACKAGES = "updatePackages";





const state = {
    rules: [],
    ruleDetail:{},
    promotions: [],
    promotionDetail:{},
    packages: [],
    packageDetail:{},

};

const getters = {
    rules(state) {
        return state.rules;
    },
    ruleDetail(state) {
        return state.ruleDetail;
    },
    promotions(state) {
        return state.promotions;
    },
    promotionDetail(state) {
        return state.promotionDetail;
    },
    packages(state) {
        return state.packages;
    },
    packageDetail(state) {
        return state.packageDetail;
    },
};

const actions = {
    [GET_LIST_RULES](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_RULES).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_RULES, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_PROMOTIONS](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_PROMOTIONS).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_PROMOTIONS, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_PACKAGES](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_PACKAGES).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_PACKAGES, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_RULES](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_RULES}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_RULES, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_PROMOTIONS](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PROMOTIONS}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PROMOTIONS, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_PACKAGES](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PACKAGES}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PACKAGES, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_RULES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_RULES}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [SAVE_PROMOTIONS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_PROMOTIONS}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [SAVE_PACKAGES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_PACKAGES}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_RULES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_RULES}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_PROMOTIONS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_PROMOTIONS}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_PACKAGES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_PACKAGES}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_RULES](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_RULES}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_PROMOTIONS](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_PROMOTIONS}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_PACKAGES](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_PACKAGES}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_RULES](state, data) {
        state.rules = data.data;
    },
    [SET_DETAIL_RULES](state, data) {
        state.ruleDetail = data.data;
    },
    [SET_LIST_PROMOTIONS](state, data) {
        state.promotions = data.data;
    },
    [SET_DETAIL_PROMOTIONS](state, data) {
        state.promotionDetail = data.data;
    },
    [SET_LIST_PACKAGES](state, data) {
        state.packages = data.data;
    },
    [SET_DETAIL_PACKAGES](state, data) {
        state.packageDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};